
  export default {
    name: 'SectionHeadlineWithTextAndCards',
    components: {
      CardWithImageAndButton: () =>
        import('@/components/elements/CardWithImageAndButton'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data() {
      return {
        customColumn: this.section.number_of_elements
          ? 12 / Number(this.section.number_of_elements.split('_')[1])
          : 4,
      };
    },
    serverCacheKey: function (props) {
      return 'section-headline-with-text-and-card-' + props.section.id;
    },
    created() {
      if (process.client) {
        if (
          this.$vuetify.breakpoint.width <=
          this.$vuetify.breakpoint.thresholds.xs
        ) {
          this.customColumn = '12';
        } else if (
          this.$vuetify.breakpoint.width >
            this.$vuetify.breakpoint.thresholds.xs &&
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          this.section.number_of_elements !== 'three_3' &&
          this.section.number_of_elements != null
        ) {
          this.customColumn = '6';
        } else if (
          this.$vuetify.breakpoint.width >
            this.$vuetify.breakpoint.thresholds.xs &&
          this.$vuetify.breakpoint.width <=
            this.$vuetify.breakpoint.thresholds.sm &&
          (this.section.number_of_elements === 'three_3' ||
            this.section.number_of_elements === null)
        ) {
          this.customColumn = '12';
        }
      }
    },
  };
